import { RouteObject } from "react-router-dom";

import ErrorBoundary from "src/components/Errors/ErrorBoundary.tsx";
import { FilesPage } from "src/pages/Files/FilesPage.tsx";
import { SpecificationsPage } from "src/pages/Specifications/SpecificationsPage.tsx";

export const importExportRoutes: RouteObject[] = [
  {
    path: "/specifications",
    Component: SpecificationsPage,
    ErrorBoundary: ErrorBoundary,
  },
  {
    path: "/import-export",
    Component: FilesPage,
    ErrorBoundary: ErrorBoundary,
  },
];
